function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0H0V20H20V0Z",
  fill: "white",
  fillOpacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.91634 3.3335H17.083C17.5432 3.3335 17.9163 3.70659 17.9163 4.16683V15.8335C17.9163 16.2937 17.5432 16.6668 17.083 16.6668H2.91634C2.4561 16.6668 2.08301 16.2937 2.08301 15.8335V4.16683C2.08301 3.70659 2.4561 3.3335 2.91634 3.3335Z",
  stroke: "#3FD5D3",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.04199 7.5C6.38717 7.5 6.66699 7.22018 6.66699 6.875C6.66699 6.52982 6.38717 6.25 6.04199 6.25C5.69681 6.25 5.41699 6.52982 5.41699 6.875C5.41699 7.22018 5.69681 7.5 6.04199 7.5Z",
  stroke: "#3FD5D3",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24967 10L8.33301 11.6667L10.833 8.75L17.9163 14.1667V15.8333C17.9163 16.2936 17.5432 16.6667 17.083 16.6667H2.91634C2.4561 16.6667 2.08301 16.2936 2.08301 15.8333V14.1667L6.24967 10Z",
  stroke: "#3FD5D3",
  strokeWidth: 1.66667,
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.f15da365.svg";
export { ForwardRef as ReactComponent };